export default class PasswordUtils{
  /**
   * パスワードのバリデーション
   * @param password
   */
  static validPassword(password: string): boolean{
    const regex = /^[a-zA-Z0-9!#$%&\\/=?@]+$/;
    const alpha = /[a-zA-Z]/;
    const numeric = /[0-9]/;
    const mark = /[!#$%&\\/=?@]/;
    let retCnt = 0
    //8-32文字
    //半角英字
    //半角記号
    //半角数字
    if(password.length >= 8 && password.length <= 32){
      if(regex.test(password)){
        if(alpha.test(password)){
          retCnt++
          console.log('アルファ')
        }
        if(numeric.test(password)){
          retCnt++
          console.log('数字')
        }
        if(mark.test(password)){
          retCnt++
          console.log('マーク')
        }
        return retCnt>=2
      }else{
        return false
      }
    }else{
      return false
    }
  }
}
//半角英字 or 半角数字 or 半角記号
const p = 'aaaaaaaaaaaaaa-'
console.log(PasswordUtils.validPassword(p)) //true